import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { OpenPanel } from '@openpanel/web';

new OpenPanel({
  clientId: 'db9fb95e-03b1-4d0e-ad98-204ee60a65dc',
  apiUrl: 'https://op.blatstudio.com/api',
  trackScreenViews: true,
  trackOutgoingLinks: true,
  trackAttributes: true,
});

const app = createApp(App);

app.use(router)
app.use(store)
app.mount('#app')
